/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
export default function isNil(value) {
    /*
     * This is a double equals check on purpose because double equals asserts true
     * for both `null` and `undefined`.
     */
    // eslint-disable-next-line eqeqeq
    return value == null;
}
